import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69d20b56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = { class: "payment is-centered" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "32",
    cy: "32",
    r: "32",
    fill: "#EAEEFF"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M32.5 18.4478C26.7005 18.4478 22 21.5335 22 25.3433C22 29.1531 26.7005 32.2388 32.5 32.2388C38.2995 32.2388 43 35.3246 43 39.1343C43 42.9441 38.2995 46.0299 32.5 46.0299M32.5 18.4478V46.0299M32.5 18.4478C36.385 18.4478 39.78 19.8338 41.5965 21.8955L32.5 18.4478ZM32.5 18.4478V15M32.5 46.0299V49.4776M32.5 46.0299C28.615 46.0299 25.22 44.6439 23.4035 42.5821L32.5 46.0299Z",
    stroke: "#7592F9",
    "stroke-width": "4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Make your wire payment to", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line ph" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line ph" }, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "wire-info" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "has-text-left mb-1" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Account Number")
], -1))
const _hoisted_12 = { class: "is-flex" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "button"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-spin mdi-loading" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "23",
  viewBox: "0 0 20 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.6153 0.205139H2.30763C1.17942 0.205139 0.256348 1.12822 0.256348 2.25642V16.6154H2.30763V2.25642H14.6153V0.205139ZM13.5897 4.3077L19.7435 10.4615V20.718C19.7435 21.8462 18.8204 22.7692 17.6922 22.7692H6.39994C5.27173 22.7692 4.35891 21.8462 4.35891 20.718L4.36917 6.35898C4.36917 5.23078 5.28199 4.3077 6.41019 4.3077H13.5897ZM12.564 11.4872H18.2051L12.564 5.84616V11.4872Z",
    fill: "#828C99"
  })
], -1))
const _hoisted_18 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_19 = { class: "wire-info" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "has-text-left mb-1" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Routing Number")
], -1))
const _hoisted_21 = { class: "is-flex" }
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  key: 0,
  class: "button"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-spin mdi-loading" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "23",
  viewBox: "0 0 20 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.6153 0.205139H2.30763C1.17942 0.205139 0.256348 1.12822 0.256348 2.25642V16.6154H2.30763V2.25642H14.6153V0.205139ZM13.5897 4.3077L19.7435 10.4615V20.718C19.7435 21.8462 18.8204 22.7692 17.6922 22.7692H6.39994C5.27173 22.7692 4.35891 21.8462 4.35891 20.718L4.36917 6.35898C4.36917 5.23078 5.28199 4.3077 6.41019 4.3077H13.5897ZM12.564 11.4872H18.2051L12.564 5.84616V11.4872Z",
    fill: "#828C99"
  })
], -1))
const _hoisted_27 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_28 = {
  key: 1,
  class: "amount"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Amount due:", -1))
const _hoisted_30 = { class: "mt-3" }
const _hoisted_31 = {
  key: 2,
  class: "amount"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ph mb-3" }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "ph" }, null, -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 3,
  class: "amount-received is-block has-text-centered mt-2"
}
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"columns\" data-v-69d20b56><div class=\"column\" data-v-69d20b56><div class=\"disclaimer\" data-v-69d20b56><p class=\"mt-5\" data-v-69d20b56>Disclaimer: You must send money from a bank account that matches the identity of the name on the invoice. Once your payment is received, you&#39;ll receive an email notification.</p><p class=\"mt-3\" data-v-69d20b56>An email has also been sent out to you with these payment details.</p></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InvoiceSteps = _resolveComponent("InvoiceSteps")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_InvoiceSteps, {
      steps: _ctx.steps,
      currentStep: 2
    }, null, 8, ["steps"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("input", {
                class: "input",
                value: _ctx.accountNumber,
                type: "text",
                readonly: ""
              }, null, 8, _hoisted_13),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("button", _hoisted_14, _hoisted_16))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyAccountNumber && _ctx.copyAccountNumber(...args))),
                    onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAccountTooltip = true)),
                    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAccountTooltip = false))
                  }, [
                    _hoisted_17,
                    (_ctx.showAccountTooltip)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Copy account number"))
                      : _createCommentVNode("", true)
                  ], 32))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("input", {
                class: "input",
                value: _ctx.routingNumber,
                type: "text",
                readonly: ""
              }, null, 8, _hoisted_22),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("button", _hoisted_23, _hoisted_25))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.copyRoutingNumber && _ctx.copyRoutingNumber(...args))),
                    onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showRoutingTooltip = true)),
                    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showRoutingTooltip = false))
                  }, [
                    _hoisted_26,
                    (_ctx.showRoutingTooltip)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Copy routing number"))
                      : _createCommentVNode("", true)
                  ], 32))
            ])
          ]),
          (_ctx.invoice.uuid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("h3", _hoisted_30, _toDisplayString(_ctx.currency(_ctx.invoice.outstanding_amount, _ctx.invoice.currency, 2, true)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34)),
          (_ctx.isPartiallyPaid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("small", null, "Received: " + _toDisplayString(_ctx.currency(_ctx.invoice.total_price - _ctx.invoice.outstanding_amount, _ctx.invoice.currency, 2, true)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_36
  ], 64))
}